import { APIConfiguration } from '@savgroup-front-common/configuration';
import {
  COMMON_QUERY_PARAMS,
  SUPPORTED_METHODS,
} from '@savgroup-front-common/constants/shared';
import { prepareResponseFailure } from '@savgroup-front-common/core/helpers';
import {
  ApiRequestDescriptor,
  executeQuery,
} from '@savgroup-front-common/core/services';
import {
  BackResponse,
  BackResponseFailure,
} from '@savgroup-front-common/types';

const ENDPOINT = `${APIConfiguration.claim}claims/${COMMON_QUERY_PARAMS.CLAIM_ID}/summary`;

export interface ClaimContextSummary {
  fileNumber?: string;
  templateName?: string;
  headerMessage?: string;
  contentTitle?: string;
  content1?: string;
  content2?: string;
  documents?: {
    type: string;
    url?: string;
  }[];
  issueId: string;
  issueName?: string;
  reasonName?: string;
  solutionName?: string;
  fileId?: string;
  validationTemplateName?: string;
  validationHeaderMessage?: string;
  validationContentTitle?: string;
  validationContent1?: string;
  validationContent2?: string;
  originPathway: string;
}

export interface GetClaimContextSummaryQueryArgs {
  claimId: string;
}

export const getClaimContextSummaryRequest = (
  payload: GetClaimContextSummaryQueryArgs,
): ApiRequestDescriptor => ({
  url: ENDPOINT.replace(COMMON_QUERY_PARAMS.CLAIM_ID, payload.claimId),
  config: { method: SUPPORTED_METHODS.GET },
});

const getClaimContextSummaryQuery = async (
  payload: GetClaimContextSummaryQueryArgs,
): Promise<BackResponse<ClaimContextSummary> | BackResponseFailure> => {
  try {
    return await executeQuery<BackResponse<ClaimContextSummary>>(
      getClaimContextSummaryRequest(payload),
    );
  } catch (exception) {
    return prepareResponseFailure(exception);
  }
};

export default getClaimContextSummaryQuery;
